import { Box, Grid2, Typography, IconButton, CircularProgress } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { React, CustomButton, AppLayout, useApi, Toaster, CustomForecast } from "../../utils/globalImports";
import { useState, useEffect, useRef } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import BaseLineCustomForecast from "./BaseLineCustomForecast";
import {
    ProjectBaselineResponse,
    ProjectBaseline,
    BaselineDetailRequest,
    SaveBaselineRequest,
    ProjectBaselineDetail, Proposal, Project,
    ProjectBaselineStatus,
    ProjectBaselineDescriptions,
    statusColors,
    BaselineResponse,
} from "../../interfaces/baselineInterface";
import SummaryBaseline from "./SummeryBaseLine";
import { buildSummaryRows } from "../../interfaces/summaryBuilder";

const ForecastDisplayType = {
    LiveDefinite: 1,
    LiveProposed: 2,
    ThirdPartyCost: 5,
};

// 👇 Define the ref interface for child component
interface BaseLineCustomForecastRef {
    triggerSave: () => Promise<boolean>;
}
interface ActiveMonthDetails{
  year:number,
  month:number,
  currentLockDate:Date,
  minAllowedDate:Date,
  maxAllowedDate:Date
}



const CreatebaseLine: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { execute } = useApi();
    // Preserve changed cell highlight data across navigation
    const [changedCellsMap, setChangedCellsMap] = useState<
        Record<number, Record<string, boolean>>
    >({});
    const currentBaselineId = location.state?.currentBaselineId ?? 0;
    const [currentBaseline, setCurrentBaseline] = useState<BaselineResponse | null>(null);
    const [projects, setProjects] = useState<Project[]>([]);
    const [currentIndex, setCurrentIndex] = useState(-1);

    const [forecastType, setForecastType] = useState<number>(0);
    const [forecastData, setForecastData] = useState<Proposal[] | null>(null);
    const [allBaselineData, setAllBaselineData] = useState<ProjectBaselineResponse | null>(null);
    const [allUpdatedRows, setAllUpdatedRows] = useState<ProjectBaselineDetail[]>([]);
    const [manualUpdatedRows, setManualUpdatedRows] = useState<ProjectBaselineDetail[]>([]);
    const [summaryRows, setSummaryRows] = useState<ProjectBaselineDetail[]>([]);
    const [loading, setLoading] = useState(false);
    const [toast, setToast] = useState({ open: false, message: "", type: "success" });
    const [activeMonthDetails,setActiveMonthDetails]=useState<ActiveMonthDetails|null>(null);

    const forecastRef = useRef<BaseLineCustomForecastRef | null>(null);
    //it should be the Active Month not the CurrentMonth
    const monthName = activeMonthDetails
  ? new Date(
      activeMonthDetails.year,
      activeMonthDetails.month - 1,
      1
    ).toLocaleString("default", { month: "short" })
  : "";
 

const year = activeMonthDetails?.year ?? "";
    const userId = Number(localStorage.getItem("userId"));
    const [isSummaryClick, setSummaryClick] = useState(false);

    // 🔧 Helper: format date as yyyy-MM-dd


    // ⏬ Fetch all project baseline data once
    useEffect(() => {
        const fetchAllBaselineData = async () => {
            try {
                setLoading(true);

                const projectManagerID = userId;

                const url = `/ProjectBaseline/GetProjectBaseLineAsync?baselineID=${currentBaselineId}&projectManagerID=${projectManagerID}`;
                const { data } = (await execute("get", url)) as { data: ProjectBaselineResponse };
                setAllBaselineData(data);
                setProjects(data.projects);

                if (data.projects.length > 0) {
                    setCurrentIndex(0);
                    if (currentBaselineId > 0) {
                        const url = `/ProjectBaseline/${currentBaselineId}`;
                        const { data } = (await execute("get", url)) as { data: BaselineResponse };
                        setCurrentBaseline(data);
                    }
                }

            } catch (error: any) {
                if (error.name === "CanceledError") return;
                console.error("Error fetching all baseline data:", error);
            } finally {
                setLoading(false);
            }

        };
        fetchAllBaselineData();
        fetchActiveMonthDetails();
    }, []);

    // 🔄 Update forecastData when project or type changes
    useEffect(() => {

        if (!allBaselineData || !forecastType || !projects.length)
            return;

        const project = allBaselineData.projects?.find(
            (proj) => proj.projectId === projects[currentIndex].projectId
        );

        const projectProposals = {
            [ForecastDisplayType.LiveProposed]: project?.proposedProposals,
            [ForecastDisplayType.LiveDefinite]: project?.definiteProposals,
            [ForecastDisplayType.ThirdPartyCost]: project?.thridPartyProposals
        }[forecastType] || [];

        setForecastData(projectProposals || []);
    }, [forecastType, currentIndex]);

    const fetchActiveMonthDetails=async()=>{
        try {
      const {data} = await execute<ActiveMonthDetails>("get",`BaselineConfig/GetActiveMonthDetails`);
      setActiveMonthDetails(data)
    }
    catch(ex){
        setToast({open: true,message: "Error Fetch Active Month",type: "error"});
    }
    }
    const handleSummaryClick = () => {
        const summaryRows = buildSummaryRows(allBaselineData, manualUpdatedRows, ForecastDisplayType);
        setSummaryRows(summaryRows)
        console.log("Summery rows",summaryRows)
        //setAllUpdatedRows(summaryRows);
        setSummaryClick(true);
    };


    const handlebackToProjects = () => {
        setSummaryClick(false);
    }

    // 🔁 Navigation handlers
    const handleNext = () => {
        if (currentIndex < projects.length - 1) {
            setCurrentIndex((prev) => prev + 1);
        }
    };

    const handlePrevious = () => {
        if (currentIndex > 0) {
            setCurrentIndex((prev) => prev - 1);
        }
    };


    // 🧩 Render UI
    return (
        <AppLayout>
            <div>
                <h1 style={{ color: "#1e66ab" }}> {currentBaselineId > 0 ? "Edit" : "Create"} Base Line - {monthName} {year}</h1>
                {currentBaseline && currentBaseline.id > 0 && currentBaselineId && (
                    <Typography variant="h6" sx={{ color: statusColors[currentBaseline.status], fontWeight: "bold", mb: 1 }}>
                        Baseline Status: {ProjectBaselineDescriptions[currentBaseline.status]}
                    </Typography>
                )}
                <hr
                    style={{
                        backgroundColor: "#96c121",
                        height: "2px",
                        border: "none",
                        marginBottom: "20px",
                    }}
                />

            </div>

            <Box
                sx={{
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                }}
            >
                {/* ===== Only render UI when baseline data exists ===== */}
                {allBaselineData && allBaselineData.projects.length > 0 ? (
                    <>
                        {/* ===== Header Section ===== */}
                        <Box
                            sx={{
                                position: "sticky",
                                top: 0,
                                zIndex: 10,
                                backgroundColor: "white",
                                borderBottom: "1px solid #ddd",
                                p: 3,
                            }}
                        >
                            {/* === Project Navigation === */}
                            {!isSummaryClick && (
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        mb: 2,
                                    }}
                                >
                                    <IconButton
                                        onClick={handlePrevious}
                                        disabled={currentIndex === 0}
                                        sx={{
                                            color: "black",
                                            border: "2px solid black",
                                            borderRadius: "50%",
                                            mr: 2,
                                        }}
                                    >
                                        <ArrowBackIcon />
                                    </IconButton>

                                    <Typography
                                        variant="h6"
                                        sx={{
                                            color: "#1e66ab",
                                            fontWeight: "bold",
                                            minWidth: "200px",
                                        }}
                                    >
                                        {projects[currentIndex]?.name || "No Project"}{" "}
                                        [
                                        <Box
                                            component="span"
                                            sx={{
                                                color: statusColors[projects[currentIndex]?.status] || "#000",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            Status -  {ProjectBaselineDescriptions[projects[currentIndex]?.status]}
                                        </Box>
                                        ]
                                    </Typography>

                                    <IconButton
                                        onClick={handleNext}
                                        disabled={currentIndex === projects.length - 1}
                                        sx={{
                                            color: "black",
                                            border: "2px solid black",
                                            borderRadius: "50%",
                                            ml: 2,
                                        }}
                                    >
                                        <ArrowForwardIcon />
                                    </IconButton>
                                </Box>
                            )}

                            {/* === Forecast Type Buttons === */}
                            <Grid2 container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                                {!isSummaryClick && (
                                    <>
                                        {[
                                            ForecastDisplayType.LiveDefinite,
                                            ForecastDisplayType.LiveProposed,
                                            ForecastDisplayType.ThirdPartyCost].map((type) => (
                                                <Grid2 key={type}>
                                                    <CustomButton
                                                        onClick={() => setForecastType(type)}
                                                        backgroundColor={
                                                            forecastType === type ? "#1e66ab" : "#f0f0f0"
                                                        }
                                                        sx={{
                                                            color: forecastType === type ? "white" : "#1e66ab",
                                                            textTransform: "none",
                                                        }}
                                                    >
                                                        {
                                                            type === ForecastDisplayType.LiveDefinite
                                                                ? "Definite"
                                                                : type === ForecastDisplayType.LiveProposed
                                                                    ? "Proposed"
                                                                    : type === ForecastDisplayType.ThirdPartyCost
                                                                        ? "Third Party"
                                                                        : "Unknown"
                                                        }
                                                    </CustomButton>
                                                </Grid2>
                                            ))}
                                    </>
                                )}


                                {/* === Summary Button (only on last project) === */}
                                {(currentIndex === projects.length - 1 && !isSummaryClick) && (
                                    <Grid2 sx={{ ml: "auto" }}>
                                        <CustomButton
                                            //disabled={!forecastData}
                                            onClick={handleSummaryClick}
                                        >
                                            Go to Summary
                                        </CustomButton>
                                    </Grid2>
                                )}

                            </Grid2>

                            {isSummaryClick && (
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "left",
                                        justifyContent: "space-between",
                                        mt: 2,
                                    }}
                                >
                                    <Box sx={{ display: "flex", alignItems: "left" }}>
                                        <IconButton
                                            onClick={handlebackToProjects}
                                            sx={{
                                                color: "black",
                                                border: "2px solid black",
                                                borderRadius: "50%",
                                                mr: 1.5,
                                            }}
                                        >
                                            <ArrowBackIcon />
                                        </IconButton>
                                        <Typography
                                            variant="h5"
                                            sx={{ color: "#1e66ab", fontWeight: "bold", textAlign: "left", mt: 1 }}
                                        >
                                            Baseline Summary – {monthName} {year}
                                        </Typography>
                                    </Box>
                                </Box>
                            )}

                        </Box>

                        {/* ===== Scrollable Table Section ===== */}
                        <Box
                            sx={{
                                flex: 1,
                                overflowY: isSummaryClick ? "" : "auto",
                                p: 3,
                                position: "relative",
                            }}
                        >
                            {loading && (
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: "rgba(255,255,255,0.6)",
                                        zIndex: 20,
                                    }}
                                >
                                    <CircularProgress />
                                </Box>
                            )}

                            {/* ===== Forecast Display ===== */}

                            {!isSummaryClick ? ( // 👈 Only render this block when summary is NOT clicked
                                projects[currentIndex] ? (
                                    forecastData && forecastType ? (
                                        <BaseLineCustomForecast
                                            ref={forecastRef}
                                            forecastData={forecastData}
                                            forecastType={forecastType}
                                            startDate={projects[currentIndex]?.startDate}
                                            endDate={projects[currentIndex]?.endDate}
                                            currentProjectID={projects[currentIndex].projectId}
                                            initialUpdatedRows={manualUpdatedRows.filter(
                                                (r) => r.ProjectID === projects[currentIndex].projectId
                                            )}
                                            // ✅ Preserve color highlight per project
                                            changedCells={changedCellsMap[projects[currentIndex].projectId] || {}}
                                            setChangedCells={(updated) =>
                                                setChangedCellsMap((prev) => ({
                                                    ...prev,
                                                    [projects[currentIndex].projectId]:
                                                        typeof updated === "function"
                                                            ? updated(prev[projects[currentIndex].projectId] || {})
                                                            : updated,
                                                }))
                                            }
                                            onUpdateRows={(updatedRowsForProject) => {
                                                setManualUpdatedRows((prev) => [
                                                    ...prev.filter(
                                                        (r) =>
                                                            !updatedRowsForProject.some(
                                                                (u) =>
                                                                    u.ProjectID === r.ProjectID &&
                                                                    u.FeeStageID === r.FeeStageID &&
                                                                    u.BaselineMonth === r.BaselineMonth
                                                            )
                                                    ),
                                                    ...updatedRowsForProject,
                                                ]);
                                            }}
                                            onForecastValueChange={(projectId, feeStageId, month, newValue) => {
                                                setForecastData((prev) =>
                                                    prev?.map((proposal) => ({
                                                        ...proposal,
                                                        categories: proposal.categories.map((cat) => ({
                                                            ...cat,
                                                            subcategories: cat.subcategories.map((sub) => ({
                                                                ...sub,
                                                                feestages: sub.feestages.map((fs) =>
                                                                    fs.feestageID === feeStageId
                                                                        ? {
                                                                            ...fs,
                                                                            forecasts: fs.forecasts.map((f) =>
                                                                                new Date(f.monthDate).getMonth() ===
                                                                                    new Date(month).getMonth() &&
                                                                                    new Date(f.monthDate).getFullYear() ===
                                                                                    new Date(month).getFullYear()
                                                                                    ? { ...f, forecastValue: newValue }
                                                                                    : f
                                                                            ),
                                                                        }
                                                                        : fs
                                                                ),
                                                            })),
                                                        })),
                                                    }))
                                                )
                                            }}
                                            readOnly={!(projects[currentIndex]?.status === ProjectBaselineStatus.Created ||
                                                projects[currentIndex]?.status === ProjectBaselineStatus.RejectedbySMT ||
                                                projects[currentIndex]?.status === ProjectBaselineStatus.RejectedbyCommercialLead)}
                                        />
                                    ) : (
                                        <Typography color="text.secondary">
                                            Select a forecast type to view data
                                        </Typography>
                                    )
                                ) : (
                                    <Typography>No project available</Typography>
                                )
                            ) : (
                                <SummaryBaseline
                                    allUpdatedRows={summaryRows}
                                    monthName={activeMonthDetails? activeMonthDetails?.month:new Date().getMonth()+1}
                                    year={activeMonthDetails?activeMonthDetails?.year : new Date().getFullYear()}
                                    currentBaselineId={currentBaselineId}
                                    forecastType={forecastType}
                                />
                            )}

                        </Box>
                    </>
                ) : (
                    // ===== No Data Fallback =====
                    <Box
                        sx={{
                            height: "100vh",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                            color: "text.secondary",
                        }}
                    >
                        {loading ? (
                            <CircularProgress />
                        ) : (
                            <Typography>No baseline data available</Typography>
                        )}
                    </Box>
                )}
            </Box>

        </AppLayout >
    );
};

export default CreatebaseLine;
